/** Pure run-status helpers shared by the full-screen overlays. */

import type { RunInfo } from "../../../api/client.js";

export const ACTIVE_RUN_STATUSES = new Set(["running", "pending", "paused"]);

export function isActiveRun(run: RunInfo): boolean {
  return ACTIVE_RUN_STATUSES.has(run.status);
}

/** Active runs first, then most-recently-started. Does not mutate the input. */
export function orderRuns(runs: RunInfo[]): RunInfo[] {
  return [...runs].sort((a, b) => {
    const aActive = isActiveRun(a) ? 1 : 0;
    const bActive = isActiveRun(b) ? 1 : 0;
    if (aActive !== bActive) return bActive - aActive;
    return b.startedAt - a.startedAt;
  });
}
